<nz-tabset nzSize="large" [nzSelectedIndex]="index" [nzAnimated]="false">
  <ng-container *ngIf="entityType === 'type'">
    <nz-tab [nzTitle]="'component.sidebar.tab_inventory' | translate">
      <div class="content">
        <host-inventory-panel
          [dateRange]="dateRange"
          [nights]="nights"
          [entity]="$any(entity)"
          (success)="onClickCancel()"
        ></host-inventory-panel>
      </div>
    </nz-tab>
  </ng-container>

  <ng-container *ngIf="entityType === 'house'">
    <nz-tab [nzTitle]="'component.sidebar.tab_order' | translate" (nzClick)="updateTabIndex('manual-order')">
      <div class="content">
        <host-manual-order
          #orderCMP
          [dateRange]="dateRange"
          [house]="$any(entity)"
          (success)="onClickCancel()"
        ></host-manual-order>
      </div>
    </nz-tab>
    <nz-tab
      [nzTitle]="'component.sidebar.tab_status' | translate"
      (nzClick)="updateTabIndex('hostex-status')"
      *ngIf="allowModifyAvailable"
    >
      <div class="content">
        <host-hostex-panel
          [entity]="$any(entity)"
          [listOfForbiddenDates]="listOfForbiddenDates"
          [dateRange]="dateRange"
          [nights]="nights"
          (success)="onClickCancel()"
        ></host-hostex-panel>
      </div>
    </nz-tab>
    <nz-tab
      [nzTitle]="'component.sidebar.tab_price' | translate"
      (nzClick)="updateTabIndex('hostex-price')"
      *ngIf="listOfHostexPriceHouses?.length"
    >
      <div class="content">
        <host-hostex-price
          [dateRange]="dateRange"
          [listOfHouse]="listOfHostexPriceHouses"
          [listOfPrice]="listOfHostexPricePrices"
          (onCheckboxChange)="fetchPriceList($event.house, $event.type)"
          (success)="onClickCancel()"
        ></host-hostex-price>
      </div>
    </nz-tab>
    <nz-tab
      [nzTitle]="'operate_sidebar_html_tab_rules' | translate"
      (nzClick)="updateTabIndex('rules-setting')"
      *ngIf="isInternational && listOfRulesRelevantUnits?.length"
    >
      <div class="content">
        <os-rules-setting
          [dateRange]="dateRange"
          [relevantUnits]="listOfRulesRelevantUnits"
          (success)="onClickCancel()"
        ></os-rules-setting>
      </div>
    </nz-tab>
  </ng-container>
</nz-tabset>
